require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/validator.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/validator.legacy.js
// module id = 610
// module chunks = 31